import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { light, dark } from './theme'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light,
      dark
    },
    themeCache: {
      get: key => localStorage.getItem(key),
      set: (key, value) => localStorage.setItem(key, value),
    }
  }
});
